import { useModal } from "@/features/modal/ModalStackManager";
import { Box, Button, Flex, Select, Table, TextInput } from "@mantine/core";
import { useState } from "react";

// TO BE : 기계 검색 후 검색내용 화면에 바인딩
export type Machine = {
  id: string;
  make: string;
  name: string;
  code: string;
  createdAt: string;
};

interface MachineSearchBoxProps {
  onSelect?: (machine: Machine | null) => void;
}
export const MachineSearchBox = ({ onSelect }: MachineSearchBoxProps) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { closeModal } = useModal();
  const handleRowClick = (id: string) => {
    setSelectedId(id === selectedId ? null : id); // toggle
  };

  const selectedMachine = machineMoupData.find((m) => m.id === selectedId) ?? null;

  return (
    <Box h="auto" w="auto">
      <Flex gap="md" direction={"column"}>
        <Flex gap="md">
          <Select data={["기계 제조사", "기계이름", "제조번호"]} w="8rem" />
          <TextInput placeholder="검색어를 입력하세요." w="40rem" />
          <Button>검색</Button>
        </Flex>
        <Table striped withBorder withColumnBorders>
          <thead>
            <tr>
              <th>기계 제조사</th>
              <th>기계 이름</th>
              <th>제조 번호</th>
            </tr>
          </thead>
          <tbody>
            {machineMoupData.map((machine) => {
              return (
                <tr
                  key={machine.id}
                  onClick={() => handleRowClick(machine.id)}
                  style={{
                    backgroundColor: machine.id === selectedId ? "#e0f7fa" : undefined,
                    cursor: "pointer",
                  }}
                >
                  <td>{machine.make}</td>
                  <td>{machine.name}</td>
                  <td>{machine.code}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Flex gap="sm">
          <Button w="50%" color="gray" onClick={() => closeModal("")}>
            취소
          </Button>
          {/* 선택 시 데이터 들어가게 */}
          <Button
            w="50%"
            onClick={() => {
              if (onSelect) onSelect(selectedMachine);
            }}
            disabled={!selectedMachine}
          >
            선택
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export const machineMoupData = [
  {
    id: "1",
    make: "태원정공",
    name: "STAND BENDING",
    code: "TW001-001",
    createdAt: "2025-06-01",
    pk: "TW001-001",
    isVisible: true,
  },
  {
    id: "2",
    make: "서울프레스",
    name: "1호기 250T",
    code: "P0700001",
    createdAt: "2025-06-01",
    pk: "P0700001",
    isVisible: true,
  },
  {
    id: "3",
    make: "서울프레스",
    name: "2호기 250T",
    code: "P0700002",
    createdAt: "2025-06-04",
    pk: "P0700002",
    isVisible: true,
  },
  {
    id: "4",
    make: "화일프레스",
    name: "10호기 160T",
    code: "P0700010",
    createdAt: "2025-06-04",
    pk: "P0700010",
    isVisible: true,
  },
  {
    id: "5",
    make: "국일프레스",
    name: "16호기 160T",
    code: "PM016-160",
    createdAt: "2025-06-04",
    pk: "PM016-160",
    isVisible: true,
  },
  {
    id: "6",
    make: "화일프레스",
    name: "17호기 80T",
    code: "PM017-080",
    createdAt: "2025-06-05",
    pk: "PM017-080",
    isVisible: true,
  },
  {
    id: "7",
    make: "쌍용정공",
    name: "22호기 80T",
    code: "PM022-080",
    createdAt: "2025-06-06",
    pk: "PM022-080",
    isVisible: true,
  },
  {
    id: "8",
    make: "화일프레스",
    name: "20호기 60T",
    code: "PM020-060",
    createdAt: "2025-06-06",
    pk: "PM020-060",
    isVisible: true,
  },
  {
    id: "9",
    make: "화일프레스",
    name: "5호기 200T",
    code: "P0700005",
    createdAt: "2025-06-07",
    pk: "P0700005",
    isVisible: true,
  },
  {
    id: "10",
    make: "SIMPAC",
    name: "23호기 400T",
    code: "P0700023",
    createdAt: "2025-06-07",
    pk: "P0700023",
    isVisible: true,
  },
  {
    id: "11",
    make: "화일프레스",
    name: "3호기 160T",
    code: "PM003-160",
    createdAt: "2025-06-07",
    pk: "PM003-160",
    isVisible: true,
  },
  {
    id: "12",
    make: "SIMPAC",
    name: "6호기 200T",
    code: "P0700006",
    createdAt: "2025-06-08",
    pk: "P0700006",
    isVisible: true,
  },
  {
    id: "13",
    make: "화일프레스",
    name: "13호기 80T",
    code: "PM013-080",
    createdAt: "2025-06-08",
    pk: "PM013-080",
    isVisible: true,
  },
  {
    id: "14",
    make: "SIMPAC",
    name: "21호기 110T",
    code: "PM021-110",
    createdAt: "2025-06-10",
    pk: "PM021-110",
    isVisible: true,
  },
  {
    id: "15",
    make: "화일프레스",
    name: "5호기 200T",
    code: "P0700005",
    createdAt: "2025-06-11",
    pk: "P0700005",
    isVisible: true,
  },
  {
    id: "16",
    make: "화일프레스",
    name: "20호기 60T",
    code: "PM020-060",
    createdAt: "2025-06-11",
    pk: "PM020-060",
    isVisible: true,
  },
  {
    id: "17",
    make: "쌍용정공",
    name: "22호기 80T",
    code: "PM022-080",
    createdAt: "2025-06-13",
    pk: "PM022-080",
    isVisible: true,
  },
  {
    id: "18",
    make: "화일프레스",
    name: "17호기 80T",
    code: "PM017-080",
    createdAt: "2025-06-13",
    pk: "PM017-080",
    isVisible: true,
  },
  {
    id: "19",
    make: "국일프레스",
    name: "16호기 160T",
    code: "PM016-160",
    createdAt: "2025-06-14",
    pk: "PM016-160",
    isVisible: true,
  },
  {
    id: "20",
    make: "화일프레스",
    name: "10호기 160T",
    code: "P0700010",
    createdAt: "2025-06-15",
    pk: "P0700010",
    isVisible: true,
  },
  {
    id: "21",
    make: "서울프레스",
    name: "2호기 250T",
    code: "P0700002",
    createdAt: "2025-06-16",
    pk: "P0700002",
    isVisible: true,
  },
];
